import { Injectable, inject } from '@angular/core';
import { IRootScopeService } from 'angular';
import { ROOT_SCOPE_PORT } from '../utils';

interface Discount {
  id: string | number;
  [key: string]: unknown;
}

/**
 * DiscountsService (Angular 18)
 *
 * Replaces: apps/b2b-ui/common/services/discounts/discounts.service.js
 * Manages discount model and lookup operations.
 */
@Injectable({ providedIn: 'root' })
export class DiscountsService {
  private rootScope = inject<IRootScopeService>(ROOT_SCOPE_PORT);

  model: Discount[] = [];

  // ─── Initialization ───────────────────────────────────────────────────────

  init(): boolean {
    return true;
  }

  // ─── Model management ─────────────────────────────────────────────────────

  setModel(discounts: unknown): void {
    if (discounts instanceof Array) {
      this.model = discounts as Discount[];
    }
    this.rootScope.$broadcast('DiscountsService::Update');
  }

  getModel(): Discount[] {
    return this.model;
  }

  // ─── Lookup ───────────────────────────────────────────────────────────────

  /**
   * Find a discount by id.
   * Returns object with index and code if found, false otherwise.
   */
  find(id: string | number): { index: number; code: Discount } | false {
    for (let i = 0; i < this.model.length; i++) {
      if (id === this.model[i].id) {
        return {
          index: i,
          code: this.model[i],
        };
      }
    }
    return false;
  }
}
